// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileActorDto
 */
export interface IFileActorDto {
    /**
     * 
     * @type {number}
     * @memberof IFileActorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileActorDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileActorDto
     */
    file_actor_type?: IFileActorDtoFileActorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IFileActorDto
     */
    contact_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IFileActorDtoFileActorTypeEnum {
    SYSTEM = 'SYSTEM',
    ADMIN = 'ADMIN'
}


/**
 * Check if a given object implements the IFileActorDto interface.
 */
export function instanceOfIFileActorDto(value: object): value is IFileActorDto {
    return true;
}

export function IFileActorDtoFromJSON(json: any): IFileActorDto {
    return IFileActorDtoFromJSONTyped(json, false);
}

export function IFileActorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileActorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'file_actor_type': json['file_actor_type'] == null ? undefined : json['file_actor_type'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
    };
}

export function IFileActorDtoToJSON(json: any): IFileActorDto {
    return IFileActorDtoToJSONTyped(json, false);
}

export function IFileActorDtoToJSONTyped(value?: IFileActorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'file_actor_type': value['file_actor_type'],
        'contact_id': value['contact_id'],
    };
}

